<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="检查记录单" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-button :loading="editDataLoading || saving" v-if="!disable" type="primary" @click="onSave(true)">保存</a-button>
                <a-button :loading="editDataLoading || saving" v-if="!disable" type="primary" @click="onSubmit">提交</a-button>
                <a-button :loading="editDataLoading || saving" v-if="disable" type="danger" @click="onUnSubmit">撤销</a-button>
            </template>
            <a-divider></a-divider>
            <a-layout>
                <a-layout-content class="fiexd-content">
                    <a-spin :spinning="editDataLoading">
                        <a-form ref="form" class="fun-edit-form" :label-col="{ span: 12 }" :wrapper-col="{ span: 11 }">
                            <FGCollapsiblePanel title="检查记录单">
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="8">
                                        <a-form-item label="检查记录单编号">
                                            <a-input ref="jcjlbh" v-model="editData.jcjlbh" :disabled="true" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="单据状态">
                                            <FGDictSelect ref="djzt" dictNo="JCGL100102" v-model="editData.djzt" placeholder="" :disabled="true" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="检查日期" :required="!disable">
                                            <a-date-picker ref="jcrq" v-model="editData.jcrq" valueFormat="YYYY-MM-DD" style="width:100%" :disabled="disable" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="8">
                                        <a-form-item label="填报截止日期">
                                            <a-date-picker ref="tbjzrq" v-model="editData.tbjzrq" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="提交时间">
                                            <a-input ref="tjrq" v-model="editData.tjrq" :disabled="true" />
                                        </a-form-item>
                                    </a-col>
                                    <!-- <a-col :span="8">
                                        <a-form-item label="审核结论">
                                            <a-radio-group v-model="editData.shjl" :disabled="true">
                                                <a-radio :value="1">
                                                    通过
                                                </a-radio>
                                                <a-radio :value="0">
                                                    否决
                                                </a-radio>
                                            </a-radio-group>
                                        </a-form-item>
                                    </a-col> -->
                                </a-row>
                                <!-- <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="审核意见" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                                            <a-textarea ref="shyj" v-model="editData.shyj" :disabled="true" />
                                        </a-form-item>
                                    </a-col>
                                </a-row> -->
                            </FGCollapsiblePanel>
                            <FGCollapsiblePanel title="备案信息">
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="8">
                                        <a-form-item label="单位名称" :required="!disable">
                                            <a-input ref="dwmc" v-model="editData.dwmc" :disabled="disable" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="统一社会信用代码" :required="!disable">
                                            <a-input ref="tyshxydm" v-model="editData.tyshxydm" :disabled="disable" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="实际办公地址" :required="!disable">
                                            <a-input ref="sjbgdz" v-model="editData.sjbgdz" :disabled="disable" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="8">
                                        <a-form-item label="注册地址" :required="!disable">
                                            <a-input ref="dwzcdz" v-model="editData.dwzcdz" :disabled="disable" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="联系人" :required="!disable">
                                            <a-input ref="lxr" v-model="editData.lxr" :disabled="disable" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="联系方式" :required="!disable">
                                            <a-input ref="lxfs" v-model="editData.lxfs" :disabled="disable" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="8">
                                        <a-form-item label="备案时间" :required="!disable">
                                            <a-date-picker
                                                ref="basj"
                                                v-model="editData.basj"
                                                valueFormat="YYYY-MM-DD "
                                                style="width:100%"
                                                :disabled="disable"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="开始从事工程咨询业务时间" :required="!disable">
                                            <a-date-picker
                                                ref="kscsgczxywsj"
                                                v-model="editData.kscsgczxywsj"
                                                valueFormat="YYYY-MM-DD "
                                                style="width:100%"
                                                :disabled="disable"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="咨询工程师（投资）人数" :required="!disable">
                                            <a-input-number ref="zxgcsrs" :min="0" :precision="0" v-model="editData.zxgcsrs" :disabled="disable" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="24">
                                        <a-form-item label="备案专业" :required="!disable" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                                            <FGDictSelectCN ref="bazy" dictNo="RY100110" v-model="bazy" :disabled="disable" mode="multiple" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                            <FGCollapsiblePanel title="资信等级及有效期限">
                                <a-row :gutter="[0, 6]" v-for="(item, index) in zxdjjyxqx" :key="index">
                                    <div class="item-bottom">
                                        <a-icon
                                            v-if="index === zxdjjyxqx.length - 1 && !disable"
                                            class="dynamic-delete-button"
                                            style="margin-left: 10px;color: blue"
                                            type="plus-circle"
                                            @click="addItem(zxdjjyxqx)"
                                        />
                                        <a-icon
                                            v-if="index === zxdjjyxqx.length - 1 && !disable"
                                            class="dynamic-delete-button"
                                            style="margin-left: 10px;color: red"
                                            type="minus-circle-o"
                                            @click="removeItem(zxdjjyxqx, item)"
                                        />
                                    </div>
                                    <a-col :span="6">
                                        <a-form-item :ref="'zxdjlabel' + index" label="资信等级" :required="!disable">
                                            <FGDictSelectCN :ref="'zxdj' + index" dictNo="ZX100102" v-model="item.zxdj" placeholder="" :disabled="disable" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6" v-if="item.zxdj !== '无'">
                                        <a-form-item :ref="'yxqlabel' + index" label="有效期（年）" :required="!disable">
                                            <a-input-number :ref="'yxq' + index" :min="0" :precision="0" v-model="item.yxq" :disabled="disable" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6" v-if="item.zxdj !== '无'">
                                        <a-form-item :ref="'zsdqrqlabel' + index" label="证书到期日期" :required="!disable">
                                            <a-date-picker
                                                :ref="'zsdqrq' + index"
                                                v-model="item.zsdqrq"
                                                valueFormat="YYYY-MM-DD"
                                                style="width:100%"
                                                :disabled="disable"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6" v-if="item.zxdj !== '无'">
                                        <a-form-item label="扫描件" :required="!disable">
                                            <UploadButton :state="state" :field="'field1_' + index" :attachCfg.sync="attachCfg" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                            <FGCollapsiblePanel title="资信专业技术人员配备情况">
                                <a-row :gutter="[0, 6]" v-for="(item, index) in zxzyjsrypbqk" :key="index">
                                    <div class="item-bottom">
                                        <a-icon
                                            v-if="index === zxzyjsrypbqk.length - 1 && !disable"
                                            class="dynamic-delete-button"
                                            style="margin-left: 10px;color: blue"
                                            type="plus-circle"
                                            @click="addItem(zxzyjsrypbqk)"
                                        />
                                        <a-icon
                                            v-if="index === zxzyjsrypbqk.length - 1 && !disable"
                                            class="dynamic-delete-button"
                                            style="margin-left: 10px;color: red"
                                            type="minus-circle-o"
                                            @click="removeItem(zxzyjsrypbqk, item)"
                                        />
                                    </div>
                                    <a-col :span="6">
                                        <a-form-item :ref="'zylabel' + index" label="专业" :required="!disable">
                                            <FGDictSelectCN :ref="'zy' + index" dictNo="RY100110" v-model="item.zy" placeholder="" :disabled="disable" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item :ref="'zxsgslabel' + index" label="咨询师个数" :required="!disable">
                                            <a-input-number :ref="'zxsgs' + index" :min="0" :precision="0" v-model="item.zxsgs" :disabled="disable" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item :ref="'gggslabel' + index" label="高工个数" :required="!disable">
                                            <a-input-number :ref="'gggs' + index" :min="0" :precision="0" v-model="item.gggs" :disabled="disable" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                            <FGCollapsiblePanel title="工程咨询业务情况">
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="24">
                                        <a-form-item label="业务专业" :required="!disable" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                                            <FGDictSelectCN ref="ywzy" dictNo="RY100110" v-model="ywzy" placeholder="" :disabled="disable" mode="multiple" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                            <FGCollapsiblePanel title="咨询质量管理制度建立情况">
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="8">
                                        <a-form-item label="有无咨询质量管理制度" :required="!disable">
                                            <a-radio-group v-model="zxzlglzdjlqk.ywzxzlglzd" :disabled="disable">
                                                <a-radio :value="1">
                                                    有
                                                </a-radio>
                                                <a-radio :value="0">
                                                    无
                                                </a-radio>
                                            </a-radio-group>
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]" v-for="(item, index) in zdjlqk_zdlb" :key="index">
                                    <div class="item-bottom">
                                        <a-icon
                                            v-if="index === zdjlqk_zdlb.length - 1 && !disable"
                                            class="dynamic-delete-button"
                                            style="margin-left: 10px;color: blue"
                                            type="plus-circle"
                                            @click="addItem(zdjlqk_zdlb)"
                                        />
                                        <a-icon
                                            v-if="index === zdjlqk_zdlb.length - 1 && !disable"
                                            class="dynamic-delete-button"
                                            style="margin-left: 10px;color: red"
                                            type="minus-circle-o"
                                            @click="removeItem(zdjlqk_zdlb, item)"
                                        />
                                    </div>
                                    <a-col :span="8">
                                        <a-form-item :ref="'zdmclabel' + index" label="制度名称" :required="!disable">
                                            <a-input :ref="'zdmc' + index" v-model="item.zdmc" :disabled="disable" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-item label="扫描件" :required="!disable">
                                            <UploadButton :state="state" :field="'field2_' + index" :attachCfg.sync="attachCfg_Edit" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="执行情况和相关说明(请简述)" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                                            <a-textarea ref="zxqkhxgsm" v-model="zxzlglzdjlqk.zxqkhxgsm" :disabled="disable" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                            <FGCollapsiblePanel title="咨询成果文件档案建立情况">
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="10">
                                        <a-form-item label="有无咨询成果档案管理制度" :required="!disable">
                                            <a-radio-group v-model="zxcgwjdajlqk.ywzxcgdaglzd" :disabled="disable">
                                                <a-radio :value="1">
                                                    有
                                                </a-radio>
                                                <a-radio :value="0">
                                                    无
                                                </a-radio>
                                            </a-radio-group>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="10" v-if="zxcgwjdajlqk.ywzxcgdaglzd === 1">
                                        <a-form-item label="相关证明" :required="!disable">
                                            <UploadButton :state="state" field="field3" :attachCfg.sync="attachCfg_Edit" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="10">
                                        <a-form-item label="有无档案目录电子数据库" :required="!disable">
                                            <a-radio-group v-model="zxcgwjdajlqk.ywdamldzsjk" :disabled="disable">
                                                <a-radio :value="1">
                                                    有
                                                </a-radio>
                                                <a-radio :value="0">
                                                    无
                                                </a-radio>
                                            </a-radio-group>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="10" v-if="zxcgwjdajlqk.ywdamldzsjk === 1">
                                        <a-form-item label="相关证明" :required="!disable">
                                            <UploadButton :state="state" field="field4" :attachCfg.sync="attachCfg_Edit" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="10">
                                        <a-form-item label="档案整理是否符合国家和行业标准" :required="!disable">
                                            <a-radio-group v-model="zxcgwjdajlqk.dazlsffhgjhhybz" :disabled="disable">
                                                <a-radio :value="1">
                                                    是
                                                </a-radio>
                                                <a-radio :value="0">
                                                    否
                                                </a-radio>
                                            </a-radio-group>
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="10">
                                        <a-form-item label="有无声像档案（视频、照片等）" :required="!disable">
                                            <a-radio-group v-model="zxcgwjdajlqk.sfysxda" :disabled="disable">
                                                <a-radio :value="1">
                                                    有
                                                </a-radio>
                                                <a-radio :value="0">
                                                    无
                                                </a-radio>
                                            </a-radio-group>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="10" v-if="zxcgwjdajlqk.sfysxda === 1">
                                        <a-form-item label="相关证明" :required="!disable">
                                            <UploadButton :state="state" field="field5" :attachCfg.sync="attachCfg_Edit" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="10">
                                        <a-form-item label="有无档案自查报告">
                                            <a-radio-group v-model="zxcgwjdajlqk.ywdazcbg" :required="!disable" :disabled="disable">
                                                <a-radio :value="1">
                                                    有
                                                </a-radio>
                                                <a-radio :value="0">
                                                    无
                                                </a-radio>
                                            </a-radio-group>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="10" v-if="zxcgwjdajlqk.ywdazcbg === 1">
                                        <a-form-item label="相关证明" :required="!disable">
                                            <UploadButton :state="state" field="field6" :attachCfg.sync="attachCfg_Edit" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                            <FGCollapsiblePanel title="其他材料">
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="6">
                                        <a-form-item label="自查报告" :required="!disable">
                                            <UploadButton :state="state" field="field7" :attachCfg.sync="attachCfg_Edit" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="营业执照" :required="!disable">
                                            <UploadButton :state="state" field="field8" :attachCfg.sync="attachCfg_Edit" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="咨询成果目录" :required="!disable" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                                            <UploadButton :state="state" field="field9" :attachCfg.sync="attachCfg_Edit" />
                                            <a style="margin-left: 20px" @click="templateDownload(0)">成果样表下载</a>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="单位自查材料承诺书" :required="!disable" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                                            <UploadButton :state="state" field="field10" :attachCfg.sync="attachCfg_Edit" />
                                            <a style="margin-left: 20px" @click="templateDownload(1)">承诺书下载</a>
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                        </a-form>
                    </a-spin>
                </a-layout-content>
                <a-layout-sider class="region-attach-uploadpanel">
                    <AttachDownload ref="attachdown" :attachCfg.sync="attachCfg" />
                </a-layout-sider>
            </a-layout>
        </a-page-header>
    </div>
</template>

<script>
export default {
    name: "JcqklrForm",
    props: ["dataId", "state"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            // 从表数据
            zxdjjyxqx: [
                {
                    id: this.$FG_util.uuid(),
                    jcjldid: this.dataId
                }
            ],
            zxzyjsrypbqk: [
                {
                    id: this.$FG_util.uuid(),
                    jcjldid: this.dataId
                }
            ],
            gczxywqk: [
                {
                    id: this.$FG_util.uuid(),
                    jcjldid: this.dataId
                }
            ],
            zxzlglzdjlqk: {
                id: this.$FG_util.uuid(),
                jcjldid: this.dataId,
                ywzxzlglzd: 1
            },
            zdjlqk_zdlb: [
                {
                    id: this.$FG_util.uuid(),
                    jcjldid: this.dataId
                }
            ],
            zxcgwjdajlqk: {
                id: this.$FG_util.uuid(),
                jcjldid: this.dataId,
                ywzxcgdaglzd: 0,
                ywdamldzsjk: 0,
                dazlsffhgjhhybz: 1,
                sfysxda: 0,
                ywdazcbg: 0
            },
            bazy: [],
            ywzy: []
        };
    },
    computed: {
        subTitle() {
            return this.state === 1 ? "编辑" : "查看";
        },
        disable() {
            return this.state === 2;
        },
        attachCfg() {
            return {
                fktable: "JCGL_JCQKLR",
                fkvalue: this.dataId,
                attachsource: "JCGL2001"
            };
        },
        attachCfg_Edit() {
            return {
                fktable: "JCGL_JCQKLR",
                fkvalue: this.dataId,
                attachsource: "JCGL2001"
            };
        }
    },
    watch: {
        "zxzlglzdjlqk.ywzxzlglzd": {
            handler(newVal) {
                if (newVal === 1) {
                    if (this.zdjlqk_zdlb.length === 0) {
                        this.zdjlqk_zdlb = [
                            {
                                id: this.$FG_util.uuid(),
                                jcjldid: this.dataId,
                                zdjlqkid: this.zxzlglzdjlqk.id
                            }
                        ];
                    }
                } else {
                    this.zdjlqk_zdlb = [];
                }
            },
            deep: true
        }
    },
    activated() {
        this.initData();
        this.loadData();
    },
    methods: {
        initData() {
            // 从表数据
            this.zxdjjyxqx = [
                {
                    id: this.$FG_util.uuid(),
                    jcjldid: this.dataId
                }
            ];
            this.zxzyjsrypbqk = [
                {
                    id: this.$FG_util.uuid(),
                    jcjldid: this.dataId
                }
            ];
            this.gczxywqk = {
                id: this.$FG_util.uuid(),
                jcjldid: this.dataId
            };
            this.zxzlglzdjlqk = {
                id: this.$FG_util.uuid(),
                jcjldid: this.dataId,
                ywzxzlglzd: 1
            };
            this.zdjlqk_zdlb = [
                {
                    id: this.$FG_util.uuid(),
                    jcjldid: this.dataId
                }
            ];
            this.zxcgwjdajlqk = {
                id: this.$FG_util.uuid(),
                jcjldid: this.dataId,
                ywzxcgdaglzd: 0,
                ywdamldzsjk: 0,
                dazlsffhgjhhybz: 1,
                sfysxda: 0,
                ywdazcbg: 0
            };
        },
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/jcgl/jcqklr/selectById",
                    {
                        id: this.dataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data.jcjld;
                            if (!this.editData.jcrq) {
                                this.editData.jcrq = this.$moment().format("YYYY-MM-DD");
                            }
                            if (this.editData.bazy) {
                                this.bazy = this.editData.bazy.split(",");
                            }
                            if (data.data.zxdjjyxqx && data.data.zxdjjyxqx.length > 0) {
                                this.zxdjjyxqx = data.data.zxdjjyxqx;
                            }
                            if (data.data.zxzyjsrypbqk && data.data.zxzyjsrypbqk.length > 0) {
                                this.zxzyjsrypbqk = data.data.zxzyjsrypbqk;
                            }

                            if (data.data.zxzlglzdjlqk) {
                                this.zxzlglzdjlqk = data.data.zxzlglzdjlqk;
                            }
                            if (data.data.zxzlglzdjlqk_zdlb && data.data.zxzlglzdjlqk_zdlb.length > 0) {
                                this.zdjlqk_zdlb = data.data.zxzlglzdjlqk_zdlb;
                            }
                            if (data.data.zxcgwjdajlqk) {
                                this.zxcgwjdajlqk = data.data.zxcgwjdajlqk;
                            }
                            if (data.data.gczxywqk) {
                                this.gczxywqk = data.data.gczxywqk;
                                if (this.gczxywqk.ywzy) {
                                    this.ywzy = this.gczxywqk.ywzy.split(",");
                                }
                            }
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => this.onBack());
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.onBack();
                    }
                });
        },
        // 返回列表
        onBack() {
            this.$emit("update:showPage", "Jcqklrlb");
        },
        addItem(arrays) {
            let obj = {
                id: this.$FG_util.uuid(),
                jcjldid: this.dataId
            };
            arrays.push(obj);
        },
        removeItem(arrays, item) {
            if (arrays.length > 1) {
                arrays.splice(arrays.indexOf(item), 1);
            }
        },
        checkArrayValue(array, checkFields) {
            let result = true;
            for (let index = 0; index < array.length; index++) {
                let item = array[index];
                for (let j = 0; j < checkFields.length; j++) {
                    let field = checkFields[j];
                    if (item.zxdj === "无" && ["yxq", "zsdqrq"].indexOf(field) !== -1) {
                        break;
                    }
                    if (["yxq", "zxsgs", "gggs"].indexOf(field) !== -1) {
                        if (item[field] === null) {
                            this.$FG_message.error("P0001", this.$refs[field + "label" + index][0].label).then(() => this.$refs[field + index][0].focus());
                            result = false;
                            break;
                        }
                    } else {
                        if (!item[field]) {
                            this.$FG_message.error("P0001", this.$refs[field + "label" + index][0].label).then(() => this.$refs[field + index][0].focus());
                            result = false;
                            break;
                        }
                    }
                }
            }
            return result;
        },
        onSave(showSuccess) {
            return new Promise((resolve, reject) => {
                if (!showSuccess) {
                    if (!this.editData.jcrq) {
                        this.$FG_message.error("P0001", "检查日期").then(() => this.$refs.jcrq.focus());
                        return;
                    }
                    if (!this.editData.dwmc) {
                        this.$FG_message.error("P0001", "单位名称").then(() => this.$refs.dwmc.focus());
                        return;
                    }
                    if (!this.editData.tyshxydm) {
                        this.$FG_message.error("P0001", "统一社会信用代码").then(() => this.$refs.tyshxydm.focus());
                        return;
                    }
                    if (!this.editData.sjbgdz) {
                        this.$FG_message.error("P0001", "实际办公地址").then(() => this.$refs.sjbgdz.focus());
                        return;
                    }
                    if (!this.editData.dwzcdz) {
                        this.$FG_message.error("P0001", "注册地址").then(() => this.$refs.dwzcdz.focus());
                        return;
                    }
                    if (!this.editData.lxr) {
                        this.$FG_message.error("P0001", "联系人").then(() => this.$refs.lxr.focus());
                        return;
                    }
                    if (!this.editData.lxfs) {
                        this.$FG_message.error("P0001", "联系方式").then(() => this.$refs.lxfs.focus());
                        return;
                    }
                    if (!this.editData.basj) {
                        this.$FG_message.error("P0001", "备案时间").then(() => this.$refs.basj.focus());
                        return;
                    }
                    if (!this.bazy || this.bazy.length === 0) {
                        this.$FG_message.error("P0001", "备案专业").then(() => this.$refs.bazy.focus());
                        return;
                    }
                    if (!this.editData.kscsgczxywsj) {
                        this.$FG_message.error("P0001", "开始从事工程咨询业务时间").then(() => this.$refs.kscsgczxywsj.focus());
                        return;
                    }
                    if (!this.editData.zxgcsrs && this.editData.zxgcsrs !== 0) {
                        this.$FG_message.error("P0001", "咨询工程师（投资）人数").then(() => this.$refs.zxgcsrs.focus());
                        return;
                    }
                    if (!this.checkArrayValue(this.zxdjjyxqx, ["zxdj", "yxq", "zsdqrq"])) {
                        return;
                    }
                    if (!this.ywzy || this.ywzy.length === 0) {
                        this.$FG_message.error("P0001", "业务专业").then(() => this.$refs.ywzy.focus());
                        return;
                    }
                    if (!this.checkArrayValue(this.zxzyjsrypbqk, ["zy", "zxsgs", "gggs"])) {
                        return;
                    }
                    if (!this.checkArrayValue(this.zdjlqk_zdlb, ["zdmc"])) {
                        return;
                    }
                    let fileClass = document.getElementsByClassName("uploadBtn");
                    if (fileClass.length > 0) {
                        this.$FG_message.error("请上传文件").then(() => {
                            fileClass[0].focus();
                        });
                        return;
                    }
                }
                this.saving = true;
                this.zdjlqk_zdlb.zdjlqkid = this.zxzlglzdjlqk.id;
                this.editData.bazy = this.bazy.join(",");
                this.gczxywqk.ywzy = this.ywzy.join(",");
                this.$FG_http
                    .post(
                        "./api/main/jcgl/jcqklr/save",
                        {
                            jcjld: this.editData,
                            zxdjjyxqx: this.zxdjjyxqx,
                            zxzyjsrypbqk: this.zxzyjsrypbqk,
                            zxzlglzdjlqk: this.zxzlglzdjlqk,
                            zxzlglzdjlqkZdlb: this.zdjlqk_zdlb,
                            zxcgwjdajlqk: this.zxcgwjdajlqk,
                            gczxywqk: this.gczxywqk
                        },
                        { showSuccess: showSuccess }
                    )
                    .then(({ success, data, errMsg }) => {
                        this.saving = false;
                        if (success) {
                            resolve(true);
                        }
                    });
            });
        },
        // 提交操作
        async onSubmit() {
            let data = await this.onSave(false);
            if (data) {
                this.$FG_message.confirm("P0000", "提交").then((type) => {
                    if (type === "ok") {
                        this.saving = true;
                        this.$FG_http
                            .post("./api/main/jcgl/jcqklr/submit", {
                                id: this.editData.id
                            })
                            .then(({ success, data, errMsg }) => {
                                this.saving = false;
                                if (success) {
                                    // 返回列表
                                    this.onBack();
                                }
                            });
                    }
                });
            }
        },
        //撤销操作
        onUnSubmit() {
            this.$FG_message.confirm("P0000", "撤销").then((type) => {
                if (type === "ok") {
                    this.saving = true;
                    this.$FG_http
                        .post("./api/main/jcgl/jcqklr/unSubmit", {
                            id: this.editData.id
                        })
                        .then(({ success, data, errMsg }) => {
                            this.saving = false;
                            if (success) {
                                // 返回列表
                                this.onBack();
                            }
                        });
                }
            });
        },
        templateDownload(type) {
            this.$FG_http
                .post(
                    "./api/main/jcgl/jcqklr/templateDownload",
                    {
                        type
                    },
                    {
                        responseType: "blob",
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    if (success) {
                        let aLink = document.createElement("a");
                        let blob = new Blob([data]);
                        let fileName = "成果样表.xlsx";
                        if (type === 1) {
                            fileName = "工程咨询单位线上自查材料填报承诺书.docx";
                        }
                        aLink.href = URL.createObjectURL(blob);
                        aLink.setAttribute("download", fileName); // 设置下载文件名称
                        aLink.click(); //执行下载
                        document.body.appendChild(aLink);
                        URL.revokeObjectURL(aLink.href); //释放url
                        document.body.removeChild(aLink); //释放标签
                    } else {
                        this.$FG_message.error("P0002");
                    }
                });
        }
    }
};
</script>
<style lang="scss" scoped>
.view {
    background: #fff;
    border: 0;
    color: #333;
    cursor: inherit;
}
.zpCls {
    width: 181px;
    height: 181px;
}
</style>
<style>
.cusBtnAlign .ant-modal-footer {
    text-align: center !important;
}
.view .ant-select-selection.ant-select-selection--single {
    background: #fff;
    border: 0px;
    cursor: inherit;
}
.view span.ant-select-arrow {
    display: none;
}
.view input.ant-calendar-picker-input.ant-input.ant-input-disabled {
    background: #fff;
    border: 0;
    color: #333;
    cursor: auto;
}
.view .ant-calendar-picker-icon {
    display: none;
    cursor: auto;
}

.dynamic-delete-button {
    cursor: pointer;
    position: relative;
    top: 4px;
    font-size: 24px;
    color: #999;
    transition: all 0.3s;
}
.dynamic-delete-button:hover {
    color: #777;
}
.dynamic-delete-button[disabled] {
    cursor: not-allowed;
    opacity: 0.5;
}

.fiexd-content {
    height: calc(100vh - 200px);
}
.item-bottom {
    position: absolute;
    padding-top: 6px;
    min-width: 75px;
    z-index: 999;
}
</style>
